import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Canstar App sends isCanstarApp=true as queryParam for webview pages.
 * This service is for preserving that value even when navigating to other routes without the queryParam.
 * To undo mobile app view, isCanstarApp=false needs to be specified.
 * isCanstarApp$ value is used to determine whether certain components get displayed.
 */
export class MobileAppService {
  private isCanstarAppSubject = new BehaviorSubject<boolean>(false);
  public isCanstarApp$ = this.isCanstarAppSubject.asObservable();

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      const currentParams = this.route.snapshot.queryParams;

      if (currentParams['isCanstarApp'] === 'true') {
        this.isCanstarAppSubject.next(true);
        return;
      }

      this.isCanstarAppSubject.next(false);
    });
  }
}
